import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiPencilSimpleLine } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { PopupActions } from 'reactjs-popup/dist/types';
import {
  useDeleteChannelDistributionTemplate,
  useGetChannelDistributionSectionTemplate,
} from 'services/templates/channel-distribution-template';
import { TEMPLATE_TYPE } from 'services/templates/types';
import { contractTemplateUtil } from 'utils';
import { onErrorShowToast } from 'utils/service/errorHandler';

const ChannelDistributionTemplateSection = () => {
  const id = useParamId('/templates-extended');

  const { t } = useTranslation();
  const navigate = useNavigate();

  const channelDistribution = useGetChannelDistributionSectionTemplate(id);

  const removeChannelDistribution = useDeleteChannelDistributionTemplate(id);

  const onRemoveChannelDistributionTemplate = async (actions: PopupActions) => {
    await removeChannelDistribution.mutateAsync(undefined, {
      onError: error => {
        actions.close();
        onErrorShowToast(error);
      },
      onSuccess: () => navigate('/templates-extended'),
    });
  };

  return (
    <Form.Contract
      tittle={
        channelDistribution.data?.title ??
        t('contract-template.channelDistribution.title')
      }
      backPath='templates-extended'
      topbarContent={
        <div className='flex'>
          <Button
            isClear
            onlyIcon
            onClick={() =>
              navigate(
                `/templates-extended/channel-distribution/edit/${id}/form`,
                {
                  replace: true,
                }
              )
            }>
            <Button.Description description={t('button.edit')} />

            <Button.Icon icon={<PiPencilSimpleLine />} />
          </Button>
          <MagellanPopups.DeleteWarning
            onRemove={onRemoveChannelDistributionTemplate}
            removeLoading={channelDistribution.isPending}
            name={channelDistribution.data?.title}
          />
        </div>
      }
      initialStatus={{
        ...contractTemplateUtil.distribution.initialStatus,
        displayMode: true,
      }}
      initialValues={{
        ...contractTemplateUtil.form.initialValues,
        items: channelDistribution.data
          ? middleware.template.channelDistribution.queryToForm(
              channelDistribution.data,
              '1',
              true,
              true
            )
          : contractTemplateUtil.distribution.initialValues(
              TEMPLATE_TYPE.channelDistribution
            ),
      }}
      onSubmit={() => {}}
      status={{ isLoading: channelDistribution.isLoading, displayMode: true }}
    />
  );
};

export default ChannelDistributionTemplateSection;
